<template>
  <AuthLayout>
    <template #title> Connexion </template>
    <template #subTitle> Renseignez vos infos pour continue </template>
    <template #redirectQuestion> Pas de compte? </template>
    <template #redirectLink>
      <router-link to="/register">Inscrivez-vous !</router-link>
    </template>
    <form
      class="space-y-6"
      v-bus:EVENTS.USER.LOGIN.submit.prevent
      v-redirect-on="{
        event: $constants.EVENTS.USER.LOGIN_SUCCESS,
        to: '/matches'
      }"
    >
      <!-- Email -->
      <fieldset class="fieldset">
        <legend class="fieldset-legend">Email</legend>
        <input
          name="email"
          type="email"
          required
          class="inputComponent"
          placeholder="email@exemple.com"
        />
      </fieldset>

      <!-- Mot de passe -->
      <fieldset class="fieldset">
        <legend class="fieldset-legend">Mot de passe</legend>
        <input
          name="password"
          type="password"
          required
          class="inputComponent"
          placeholder="********"
        />
      </fieldset>

      <!-- Mot de passe oublié -->
      <div class="flex justify-between text-sm">
        <span class="text-gray-600">Mot de passe oublié ?</span>
        <button
          type="button"
          class="text-blue-600 underline"
          @click="$bus.emit($constants.EVENTS.PASSWORD_RESET.REQUESTED)"
        >
          Réinitialiser
        </button>
      </div>

      <!-- Bouton continuer -->
      <button
        type="submit"
        class="buttonComponent w-full"
        :disabled="$stores?.user?.state?.loading"
        :loading="$stores?.user?.state?.loading"
      >
        Continuer
      </button>
    </form>
  </AuthLayout>
</template>

<script>
export default {
  name: 'LoginPage'
};
</script>
